import { getActionTypeFromInstance, NGXS_PLUGINS } from "@ngxs/store";

import { Logout, authStateDefaults } from "@fitscovery/auth/data-access";
import { userStateDefaults } from "@fitscovery/user/data-access";
import { partnerStateDefaults } from "@fitscovery/partner/data-access";

import { onboardingStoreDefaults } from '@fitscovery/onboarding-web/shared/store';

function onboardingWebLogoutPlugin(state: any, action: any, next: any) {

  if (getActionTypeFromInstance(action) === Logout.type) {
    state = {
      auth: authStateDefaults,
      user: userStateDefaults,
      partner: partnerStateDefaults,

      app: onboardingStoreDefaults,
      router: state.router,
      shared: state.shared
    };
  }

  return next(state, action);
}

export const OnboardingWebLogoutPluginProvider = {
  provide: NGXS_PLUGINS,
  useValue: onboardingWebLogoutPlugin,
  multi: true
};
